// Random gradients on links
var links = document.getElementsByClassName("inline-link");
var gradients = [
	"linear-gradient(90deg, #FAACA8 0%, #DDD6F3 100%)",
	"linear-gradient(to left, deeppink, blue)"];

for(i=0; i<links.length; i++) {
	links[i].style.backgroundImage = gradients[Math.floor(Math.random()*gradients.length)];
}

// Invert colors on certain sections
if(document.body.classList.contains("home")){
	var homeLink = document.querySelector(".home-link");
	var projectsTitle = document.querySelector(".projects__title");
	var projectsTitleRect = projectsTitle.getBoundingClientRect();

	window.addEventListener("scroll", function() {
		projectsTitleRect = projectsTitle.getBoundingClientRect();

		if(projectsTitleRect.top < window.innerHeight/4){
			document.body.classList.add("inverted");
			homeLink.classList.add("inverted");
			for(i=0; i<links.length; i++) {
				links[i].classList.add("inverted");
			}
		} else {
			document.body.classList.remove("inverted");
			homeLink.classList.remove("inverted");
			for(i=0; i<links.length; i++) {
				links[i].classList.remove("inverted");
			}
		}
	})
}

// Hide/show header on scroll
var header = document.querySelector("header");
var bodyTop = document.body.getBoundingClientRect().top;
var scrollVal;

if(window.innerWidth > 500){

	window.addEventListener("scroll", function() {
	  bodyTop = document.body.getBoundingClientRect().top;
	  if(bodyTop < scrollVal) {
	    header.classList.add("hide");
	  } else {
	    header.classList.remove("hide");
	  }
	  scrollVal = bodyTop;
	})
}